export default "__VITE_ASSET__B9KTzxNR__$_?url__"